(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const list = root.querySelector('[data-review-list]');
    const cards = list ? Array.from(list.children) : [];
    const filter = root.querySelector('[data-review-filter]');
    const sort = root.querySelector('[data-review-sort]');
    const status = root.querySelector('[data-review-status]');
    const dialog = root.querySelector('[data-review-dialog]');
    const content = root.querySelector('[data-review-dialog-content]');
    const fallback = root.querySelector('[data-review-fallback]');
    let opener;
    let previousOverflow;
    function update() {
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'highest') return +b.dataset.rating - +a.dataset.rating;
        if (sort.value === 'lowest') return +a.dataset.rating - +b.dataset.rating;
        if (sort.value === 'photos') return +b.dataset.photos - +a.dataset.photos;
        if (sort.value === 'videos') return +b.dataset.videos - +a.dataset.videos;
        return Date.parse(b.dataset.date) - Date.parse(a.dataset.date);
      });
      let count = 0;
      for (const card of ordered) {
        const d = card.dataset;
        card.hidden = !(filter.value === 'all' || filter.value === d.rating ||
          (filter.value === 'media' && (+d.photos + +d.videos > 0)) ||
          (filter.value === 'verified' && d.verified === 'true'));
        if (!card.hidden) count++;
        list.append(card);
      }
      status.textContent = status.dataset.countLabel.replace('[count]', count);
      root.querySelector('[data-review-empty]').hidden = count !== 0;
    }
    if (cards.length && root.dataset.complete === 'true') {
      root.querySelector('[data-review-controls]').hidden = false;
      filter.addEventListener('change', update);
      sort.addEventListener('change', update);
      update();
    }
    function open(link) {
      if (typeof dialog.showModal !== 'function') return false;
      const url = new URL(link.href, location.href);
      let media;
      if (link.hasAttribute('data-review-image')) {
        media = document.createElement('img');
        media.alt = link.getAttribute('aria-label') || '';
      } else {
        media = document.createElement('iframe');
        media.title = link.getAttribute('aria-label') || dialog.getAttribute('aria-label');
        media.allow = 'fullscreen; picture-in-picture';
      }
      media.src = url.href;
      fallback.href = url.href;
      content.replaceChildren(media);
      opener = link;
      previousOverflow = document.documentElement.classList.contains('hsg-review-modal-open');
      document.documentElement.classList.add('hsg-review-modal-open');
      dialog.showModal();
      return true;
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[data-review-image],a[data-review-video]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (open(link)) event.preventDefault();
    });
    root.querySelector('[data-review-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      content.replaceChildren();
      if (!previousOverflow) document.documentElement.classList.remove('hsg-review-modal-open');
      opener?.focus();
    });
    root.querySelectorAll('[data-review-native]').forEach(link => {
      const destination = new URL(link.href, location.href);
      const current = new URL(location.href);
      for (const [key, value] of current.searchParams) {
        if (/^(preview_theme_id|country|locale|variant|judgeme_|jdgm_)/.test(key)) destination.searchParams.set(key, value);
      }
      link.href = destination.href;
    });
    const params = new URLSearchParams(location.search);
    if ([...params.keys()].some(key => /^judgeme_(token|review_uuid|dynamic_form|follow_up_token|upload_pictures|pre_verified)$/.test(key)) || location.hash === '#judgeme') {
      const destination = new URL(root.querySelector('[data-review-native]').href, location.href);
      for (const [key, value] of params) destination.searchParams.set(key, value);
      destination.searchParams.set('view', 'hsg-judgeme');
      if ([...params.keys()].some(key => key.startsWith('judgeme_'))) destination.searchParams.delete('hsg_write');
      destination.hash = location.hash;
      location.replace(destination.href);
    }
    if (location.hash === '#judgeme_product_reviews') root.scrollIntoView();
  }
  document.querySelectorAll('[data-hsg-reviews]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hsg-reviews]').forEach(init));
})();
